import { NsBuildersFactory } from './Factory.js';
export default NsBuildersFactory;
export * from './strict.js';
